export default __webpack_public_path__ + "static/media/CRRobustoClosed.fb28996b.jpg";